import { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { EntityManagement } from "../../components";
import { API_URL, ROUTES, MEDICAL_ITEM_STATUS_OPTION } from "../../constants";
// import {
//   DataInputForm,
//   initialValues,
//   validationSchema,
// } from "./components/DataInputForm";
import {
  FilteringForm,
  initialFilteringValues,
  filteringValidationSchema,
} from "./components/FilteringForm";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { ListingPageHeader } from "./components/ListingPageHeader";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import { NotificationActions } from "../../actions";
import { EditDialog } from "./components/EditDialog";
import { CreateDialog } from "./components/CreateDialog";
import _ from "lodash";

export default function ResidentTreatmentItemsPage() {
  const dispatch = useDispatch();
  const home = useSelector((state) => state.home);
  const [apiUrl, setApiUrl] = useState({});
  const [editEntity, setEditEntity] = useState(null);
  const [filteringParams, setFilteringParams] = useState(
    initialFilteringValues
  );
  const [loading, setLoading] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [reload, setReload] = useState(false);

  const createParams = (values, coreCreateParams) => {
    console.debug("createParams");
    let params = {};
    params = coreCreateParams(values);

    params.homeId = home?.home?.id;
    params.resident = params?.resident?.id || params?.resident;
    params.treatmentItem = params?.treatmentItem?.id || params?.treatmentItem;
    //params.dateTime = moment(params.dateTime).format();

    return params;
  };

  const createFilteringParams = (values, coreCreateFilteringParams) => {
    let params = {};
    params = coreCreateFilteringParams(values);

    params.homeId = home?.home?.id;

    if (params.dateFrom != null) {
      params.dateFrom = moment(values.dateFrom).format("YYYY-MM-DD");
    }

    if (params.dateTo != null) {
      params.dateTo = moment(values.dateTo).format("YYYY-MM-DD");
    }

    return params;
  };

  const normalizeReceivedValues = (values) => {
    values.resident = values.resident.id || values.resident;
    values.treatmentItem = values.treatmentItem.id || values.treatmentItem;
    values.institution = values.institution.id || values.institution;
    values.specialist = values.specialist.id || values.specialist;

    return values;
  };

  const handleFilterChange = (values) => {
    setFilteringParams(values);
  };

  const getColumnSettings = (props) => {
    const {
      setEditingEntity,
      setDeletingEntity,
      setCopyEntity,
      clearNotification,
      loading,
    } = props;

    return [
      {
        field: "action",
        headerName: "動作",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <div>
              <Tooltip title="修改">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setEditEntity(params.row);
                    setEditOpen(true);
                  }}
                  disabled={loading}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="刪除">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setDeletingEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <DeleteOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="另存">
                <IconButton
                  color="default"
                  size="small"
                  onClick={() => {
                    clearNotification();
                    setCopyEntity(params.row);
                  }}
                  disabled={loading}
                >
                  <FileCopyOutlinedIcon />
                </IconButton>
              </Tooltip>
              {/* <Tooltip title="列印">
                                <IconButton color="default" size="small" disabled={loading}>
                                    <PrintOutlinedIcon />
                                </IconButton>
                            </Tooltip> */}
            </div>
          );
        },
      },
      {
        field: "resident",
        headerName: "院友姓名",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return (
            params.row[params.field].lastnameTc +
            params.row[params.field].firstnameTc
          );
        },
      },
      {
        field: "bed",
        headerName: "床位",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row["resident"]?.bed?.bedNo;
        },
      },
      {
        field: "date",
        headerName: "醫療項目日期",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row["dateTime"]?.substring(0, 10);
        },
      },
      {
        field: "time",
        headerName: "醫療項目時間",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row["dateTime"]?.substring(11, 16);
        },
      },
      {
        field: "treatmentItem",
        headerName: "醫療項目",
        width: 200,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row[params.field]?.nameTc;
        },
      },
      {
        field: "finishedDateTime",
        headerName: "完成醫療項目日期及時間",
        width: 200,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row[params.field]
            ? params.row[params.field]?.substring(0, 10) +
                params.row[params.field]?.substring(11, 15)
            : "--";
        },
      },
      {
        field: "remarks",
        headerName: "備註",
        width: 250,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return params.row[params.field] ? params.row[params.field] : "--";
        },
      },
      {
        field: "status",
        headerName: "醫療項目狀態",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: function (params) {
          return MEDICAL_ITEM_STATUS_OPTION.find(
            (elem) => elem.value == params.row[params.field]
          )?.label;
        },
      },
    ];
  };

  const onCreate = (values, formikActions) => {
    const submitFollowupForm = values.submitFollowupForm;
    const params = values;

    const treatmentParams = _.pick(params, [
      "resident",
      "dateTime",
      "treatmentItem",
      "finishedDateTime",
    ]);
    treatmentParams.remarks = params.treatmentRemarks;
    treatmentParams.status = params.treatmentStatus;

    // post treatment
    axios
      .post(API_URL.RESIDENT_TREATMENT_ITEM + "/", treatmentParams)
      .then((response) => {
        // if not submit followup form, then dispatch, close, and return
        if (!submitFollowupForm) {
          dispatch(NotificationActions.success(null, "已儲存"));
          formikActions.setSubmitting(false);
          setCreateOpen(false);
          setReload(!reload);
          return;
        }

        // if submit followup form, then posting followup
        const followupParams = _.pick(params, [
          "date",
          "specialist",
          "institution",
          "medicalFollowUpItems",
          "transport",
          "escorterName",
          "escorterRelationship",
        ]);
        followupParams.resident = [params.resident];
        followupParams.remarks = params.followupRemarks;
        followupParams.status = params.followupStatus;
        axios
          .post(API_URL.RESIDENT_FOLLOW_UP + "/", followupParams)
          .then((response) => {
            dispatch(NotificationActions.success(null, "已儲存"));
            formikActions.setSubmitting(false);
            setCreateOpen(false);
            setReload(!reload);
          })
          .catch((error) => {
            dispatch(NotificationActions.error(null, "錯誤"));
            formikActions.setSubmitting(false);
          });
      })
      .catch((error) => {
        dispatch(NotificationActions.error(null, "錯誤"));
        formikActions.setSubmitting(false);
      });
  }

  const onEdit = (values, formikActions) => {
    axios
      .put(API_URL.RESIDENT_TREATMENT_ITEM + "/" + values.id, {
        resident: values.resident,
        remarks: values.remarks,
        treatmentItem: values.treatmentItem,
        status: values.status,
        dateTime: values.dateTime,
        finishedDateTime: values.finishedDateTime,
      })
      .then((response) => {
        dispatch(NotificationActions.success(null, "已儲存"));
        setEditEntity(null);
        formikActions.setSubmitting(false);
        setEditOpen(false);
        setReload(!reload);
      })
      .catch((error) => {
        dispatch(NotificationActions.error(null, "錯誤"));
        formikActions.setSubmitting(false);
      });
    if (values.status == "COMPLETED" && values.nextDate !== "") {
      axios.post(API_URL.RESIDENT_TREATMENT_ITEM, {
        resident: values.resident,
        remarks: values.remarks,
        treatmentItem: values.treatmentItem,
        status: "APPOINTMENT",
        dateTime: values.nextDate,
        finishedDateTime: "",
      });
    }
  };

  useEffect(() => {
    setApiUrl({
      getAll: API_URL.RESIDENT_TREATMENT_ITEM,
      getOne: API_URL.RESIDENT_TREATMENT_ITEM,
      create: API_URL.RESIDENT_TREATMENT_ITEM,
      edit: API_URL.RESIDENT_TREATMENT_ITEM,
      delete: API_URL.RESIDENT_TREATMENT_ITEM,
      copy: API_URL.RESIDENT_TREATMENT_ITEM,
      export: API_URL.RESIDENT_TREATMENT_ITEM + "/export",
    });
  }, [home, reload]);

  return (
    <EntityManagement
      entityModel="醫療項目"
      editableFields={[
        "resident",
        "dateTime",
        "treatmentItem",
        "finishedDateTime",
        "remarks",
        "status",
      ]}
      getColumnSettings={getColumnSettings}
      createParams={createParams}
      createFilteringParams={createFilteringParams}
      normalizeReceivedValues={normalizeReceivedValues}
      filteringParams={filteringParams}
      apiUrl={apiUrl}
      // dataInputForm={DataInputForm}
      // initialValues={initialValues}
      // validationSchema={validationSchema}
      pageHeader={ListingPageHeader}
      pageHeaderProps={{
        handleFilterChange: handleFilterChange,
        setCreateOpen: setCreateOpen,
      }}
    >
      <CreateDialog
        open={createOpen}
        onClose={() => {
          setCreateOpen(null);
        }}
        onSubmit={onCreate}
      />
      <EditDialog
        open={editOpen}
        entity={editEntity}
        onClose={() => {
          setEditEntity(null);
          setLoading(false);
          setEditOpen(false);
        }}
        onSubmit={onEdit}
        normalizeReceivedValues={normalizeReceivedValues}
        apiUrl={apiUrl}
      />
    </EntityManagement>
  );
}
